import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  PulseLoader,
  FadeLoader,
  GridLoader,
  ClipLoader,
  RotateLoader
} from 'react-spinners';
import { headerHeight } from 'config/style';

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    	alignItems: 'center'
  }
})

const Loader = props => {
  const theme = useTheme();
  const classes = useStyles();

  const {
    variant = 'pulse',
    height,
    color = theme.palette.primary.main
  } = props;

  const Loader = () => {
    switch (variant) {
    case 'fade':
      return <FadeLoader size={8} color={color} />
    case 'grid':
      return <GridLoader size={8} color={color} />
    case 'clip':
      return <ClipLoader color={color} />
    case 'rotate':
      return <RotateLoader color={color} />
    case 'pulse':
    default:
      return <PulseLoader size={8} color={color} />
    }
  }

  return (
    <div className={classes.container} style={{
		  ...(height && { height: (height === 'page') ? `calc(100vh - ${headerHeight}px)` : height })
    }}>
      <Loader />
    </div>
  );
}

export default Loader;
